import { FC } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useMutation } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { useStore } from 'hooks/useRootStore';
import { emailPattern, passwordPattern } from 'utils/patterns';
import { Button } from 'components/Core/Button';
import { ControlledInput } from 'components/Inputs/ControlledInput';
import { ReactComponent as Logo } from 'assets/logo.svg';
import { LoginRequest } from 'stores/main/types';
import styles from './auth.module.scss';

const Auth: FC = () => {
  const {
    mainStore: { login, removeError },
  } = useStore();

  const navigate = useNavigate();

  const formMethods = useForm<LoginRequest>({
    defaultValues:
      process.env.NODE_ENV === 'development'
        ? { email: process.env.REACT_APP_DEV_USER_LOGIN, password: process.env.REACT_APP_DEV_USER_PASS }
        : undefined,
  });

  const {
    handleSubmit,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    formState: { errors },
  } = formMethods;

  const { mutate, isLoading } = useMutation(login, {
    mutationKey: 'LoginRequest',
    onSuccess: () => {
      removeError();
      navigate('/');
    },
  });

  const onSubmitHandler = (inputData: LoginRequest) => {
    mutate(inputData);
  };

  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <div className={styles.headerBox}>
          <div className={styles.logo}>
            <Logo height={54} width={50} />
            <span className={styles.logoText}>GeoBuyer</span>
          </div>
        </div>
      </header>
      <main className={styles.main}>
        <div className={styles.container}>
          <div className={styles.contentBox}>
            <h2 className={styles.title}>Authorization</h2>
            {/* temporary solution with any.  UseFormReturn<LoginRequest, any, undefined> interface cause ts error "type instantiation is excessively deep and possibly infinite"*/}
            {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
            <FormProvider {...(formMethods as any)}>
              <ControlledInput
                type='email'
                name='email'
                placeholder='Email'
                disabled={isLoading}
                label='Email'
                registerPattern={emailPattern}
                required
              />
              <ControlledInput
                label='Password'
                name='password'
                type='password'
                placeholder='Password'
                disabled={isLoading}
                registerPattern={passwordPattern}
                required
              />
              <div className={styles.btnBox}>
                <Button onClick={handleSubmit(onSubmitHandler)} title='Login' isSavedClass />
              </div>
            </FormProvider>
          </div>
        </div>
      </main>
    </div>
  );
};

export default observer(Auth);
